// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xuOQ","title":"styles_title__3uM6A"};